<template>
  <div class="container-fluid main-container" style="opacity: 0;" :style="{'opacity': Number(!loading)}">
    <transition name="fade" mode="out-in">
      <confirm-modal
        @answer="toggleConfirmationModal(false)"
        :confirmationRequired="true"
        v-if="confirmationModalVisible"
      ></confirm-modal>
    </transition>
    <transition name="fade" mode="out-in">
      <information-modal
        @answer="toggleConfirmationModal(false)"
        :confirmationRequired="true"
        v-if="informationnModalVisible"
      ></information-modal>
    </transition>

    <cph-alert-list :alerts="alerts"></cph-alert-list>
    <div v-loading.fullscreen.lock="loading"></div>
    <div class="row main-row" >
      <!--<div :class="[{'open': sidebarOpen}, {'d-none d-md-block': !sidebarOpen}, 'sidebar-column']">
                <cph-sidebar class="d-print-none"></cph-sidebar>
      </div>-->
      <div
        :class="[{'sidebar-opened': sidebarOpen}, {'ml-0 sidebar-width-margin': !sidebarOpen}, 'main-content pl-0']"
      >
        <cph-top-bar :class="[{'sidebar-opened': sidebarOpen}, 'topbar  d-print-none']"></cph-top-bar>
        <transition name="fade" mode="out-in">
          <router-view class="app-bg-color"></router-view>
        </transition>
        <!-- <cph-footer :class="[{'sidebar-opened': sidebarOpen}, 'topbar  d-print-none']"></cph-footer> -->
        <privacy></privacy>
      </div>
    </div>
  </div>
</template>


<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';

import GridLoader from 'vue-spinner/src/GridLoader.vue';
import CphSidebar from '../../components/Panel/Navigation/CphSidebar.vue';
import CphTopBar from '../../components/Panel/Navigation/CphTopBar.vue';
import CphFooter from '../../components/Panel/Navigation/CphFooter.vue';
import CphAlertList from '../../components/Shared/UI/Alert/CphAlertList.vue';
import ConfirmModal from '../../components/Shared/Modal/ConfirmModal.vue';
import InformationModal from '../../components/Shared/Modal/InformationModal.vue';
import Privacy from '../../components/Auth/Login/Privacy'

export default {
    name: 'CphPanel',
    components: {
        CphSidebar,
        CphTopBar,
        GridLoader,
        CphAlertList,
        ConfirmModal,
        CphFooter,
        Privacy,
        InformationModal,
    },
    computed: {
        ...mapGetters({
            sidebarOpen: 'getSidebarOpenFlag',
            loading: 'getLoadingState',
            alerts: 'getAlerts',
            confirmationModalVisible: 'isConfirmationModalVisible',
            informationnModalVisible: 'isInformationModalVisible',
            activeShop: 'getActiveShop',
            getUserId: 'getUserId',
            getUserChilds: 'getUserChilds',
            getActiveKeyAccount: 'getActiveKeyAccount'
        })
    },
    methods: {
        ...mapActions(['loginWithToken'])
    },
    async created () {
        await this.$store.dispatch('loginWithToken');
        (await this.getActiveKeyAccount)
            ? this.$store.dispatch('GetAllShops', this.getActiveKeyAccount)
            : this.$store.dispatch('GetAllShops');
        await this.$store
            .dispatch('GetChildrenDataFromUser', this.getUserId)
            .then(res => this.addUserChilds(res));
    },
    methods: {
        ...mapMutations(['addUserChilds'])
    }
};
</script>

<style lang="scss">
@import "../../../node_modules/vue-multiselect/dist/vue-multiselect.min.css";
body {
  background-color: #efeff5;
  font-family: "Poppins" !important;
  -ms-text-size-adjust: 100%;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 13px !important;
  color: #646c9a !important;
}
label {
  float: right;
  margin-bottom: 0;
  // line-height: 3em;
  &.required {
    &:after {
      content: "*";
      color: red;
    }
  }
}
.form-group {
  .form-control-sm {
    font-size: 13px;
  }
  &.row {
    padding: 3px 0;
  }
  margin-bottom: 5px;
  input {
    // line-height: 3em;
  }
  .input-group-text {
    font-size: 13px;
    color: #646c9a;
  }
}
.form-control:focus {
  outline: 0;
  border: 1px solid #8ca3f1;
  -webkit-box-shadow: none;
  box-shadow: none;
}
.alert {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: stretch;
  -ms-flex-align: stretch;
  align-items: stretch;
  padding: 1rem 2rem;
  border-radius: 3px;
  margin: 0 0 2rem 0;
  border: 1px solid transparent;
  &.alert-secondary {
    color: #75757c;
    background-color: #f9f9fc;
    border-color: #f7f7fb;
    .alert-text {
      color: #646c9a;
    }
  }
}
.map-container {
  border: 1px solid #ebedf2;
}
.panel {
  &.mh {
    height: 100%;
  }
  //background-color: #d3d3d3;
  margin-top: 10px;
  border-radius: 4px;
  box-shadow: 0px 0px 13px 0px rgba(82, 63, 105, 0.05);
  background-color: #ffffff;
  .panel-body {
    padding: 25px;
  }
  .panel-footer {
    padding: 25px;
    border-top: 1px solid #ebedf2;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
    padding-top:30px;
  }
  .panel-heading {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: stretch;
    -ms-flex-align: stretch;
    align-items: stretch;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    position: relative;
    padding: 0 25px;
    border-bottom: 1px solid #ebedf2;
    min-height: 60px;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    .panel-label {
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      -ms-flex-line-pack: flex-first;
      align-content: flex-first;
    }
    .panel-toolbar {
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      -ms-flex-line-pack: end;
      align-content: flex-end;
    }

    h3 {
      padding: 0;
      font-size: 1.3em;
      font-weight: 500;
      color: #3d4465;
      margin: 0;
      display: block;
    }
  }
}

.main-container {
  position: relative;
}

.loader {
  position: absolute;
  top: calc(50% - 25px);
  left: calc(50% - 25px);
  z-index: 500;
}

.sidebar-column {
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  padding-left: 0 !important;
  padding-right: 0 !important;
  overflow: hidden;
  width: $sidebar-width-closed;
  transition: width 0.5s ease-in;
  @include color("background-color", sidebar-bg);
  @include color("color", text-color-light);
  &.open {
    width: $sidebar-width-open !important;
  }
}

.main-content {
  position: relative;
  left: 0;
  padding: 0;
  width: 100%;
  @media screen and (max-width: 768px) {
    width: 100%;
  }
  min-height: 100vh;
  transition: margin 0.5s ease-in;

  &.sidebar-opened {
    left: 0;
    @media screen and (max-width: 768px) {
      width: 100%;
    }
  }
}

.container-fluid,
.sidebar-column,
.main-row {
  padding: 0;
  margin: 0;
}

div.row {
  &::before,
  &::after {
    content: "";
  }

  &:before,
  &:after {
    content: "";
  }
}

.main-content-container {
  padding: 15px;
}

table.table-striped {
  tbody {
    tr.table-row {
      &:hover,
      &.row-active {
        cursor: pointer;
        @include color("background-color", primary);
        @include color("color", text-color-light);
      }
    }
  }
}

ul.list {
  list-style-type: none;
}
div.list-item {
  margin: 0;
}

.input-group {
  label,
  span {
    @include color("background-color", text-color-light);
    @include color("color", primary);
    font-weight: bold;
  }
}

.multiselect__tags {
  overflow: hidden;
}

.color-picker {
  position: absolute;
  top: 40px;
  z-index: 2;
}
</style>
